import IMG_Today_Late from "../../assets/images/dashboard/Today’s Late.svg";
import IMG_Today_Time from "../../assets/images/dashboard/Today’s on time.svg";
import IMG_Absent from "../../assets/images/dashboard/absent.svg";
import IMG3 from "../../assets/images/dashboard/location-pin 1.svg";
import IMG_Present from "../../assets/images/dashboard/present.svg";
import { useGetDashboardAttendanceAnalyticsDataQuery } from "../../features/attendanceReport/attendanceReportApi";
import useError from "../../hooks/useError";
import Loader from "../ui/Loader";
import AttendanceChart from "./AttendanceChart";
import HeaderTitle from "./HeaderTitle";
import TopBarCard from "./TopBarCard";

export default function AttendanceCardAndChart() {
  const { data, isLoading, isError, error } =
    useGetDashboardAttendanceAnalyticsDataQuery({});

  useError(isError, error, "Get attendance data fail ");

  const dataList = data?.data?.stats;

  const topBarData = [
    {
      title: "Present",
      count: dataList?.totalCheckins,
      img: IMG_Present,
      color: "#D7FFEB",
      link: "/admin/attendance/daily-attendance",
      query: "status=present",
    },
    {
      title: "Absent",
      count: dataList?.totalAbsent || 0,
      img: IMG_Absent,
      color: "#FEECEF",
      link: "/admin/attendance/daily-attendance",
      query: "status=absent",
    },
    {
      title: "On time",
      count: dataList?.todayOnTimeCheckins,
      img: IMG_Today_Time,
      color: "#C9F4FB",
      link: "/admin/attendance/daily-attendance",
      query: "status=present&checkin_status=on_time",
    },
    {
      title: "Late",
      count: dataList?.todayLateCheckins,
      img: IMG_Today_Late,
      color: "#E9EFF6",
      link: "/admin/attendance/daily-attendance",
      query: "status=present&checkin_status=late",
    },
    {
      title: "On Tracking",
      count: dataList?.onTracking,
      img: IMG3,
      color: "#E8EDFF",
      link: "/admin/settings/employee-tracking",
      query: "status=1",
    },
  ];

  return (
    <div className="mt-6">
      <HeaderTitle title="attendance" />

      <div className="grid sm:grid-cols-2 gap-6">
        <div className="px-6 py-[18px] bg-white rounded-md border border-gray-light">
          {isLoading ? <Loader /> : <AttendanceChart data={dataList} />}
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {topBarData?.map((item) => (
            <TopBarCard
              key={item.title}
              title={item.title}
              count={item.count}
              color={item.color}
              img={item.img}
              link={item?.link}
              query={item?.query}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
